import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { DataSourceOrdenacaoInsensivel } from '../../../../../../shared/helpers/ordenacao-tabela.helper';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TornarPadraoDialogComponent, TornarPadraoDialogResult } from './tornar-padrao-dialog/tornar-padrao-dialog.component';
import {
    MotivoSeedRegime,
    RegimeTributarioSeedDialogComponent,
    RegimeTributarioSeedDialogData,
} from './regime-tributario-seed-dialog/regime-tributario-seed-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { ModuloEnum } from '../../../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../../../shared/enums/usuario/funcionalidade.enum';
import { TipoOperacaoEnum } from '../../../../../../shared/enums/motor-fiscal/tipo-operacao.enum';
import { RegimeTributarioEnum } from '../../../../../../shared/enums/motor-fiscal/regime-tributario.enum';
import { NaturezaOperacaoErrorCodeEnum } from '../../../../../../shared/enums/motor-fiscal/natureza-operacao-error-code.enum';
import { TipoPadraoNaturezaEnum } from '../../../../../../shared/enums/motor-fiscal/tipo-padrao-natureza.enum';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { UtilService } from '../../../../../../shared/services/util.service';
import { NaturezaOperacaoService } from '@shared/services/apis/motor-fiscal/natureza-operacao.service';
import { MotorFiscalLookupService } from '@shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { NaturezaOperacaoSeedRequest } from '@shared/services/requests/motor-fiscal/natureza-operacao-seed.request';
import { EmpresaService } from '@shared/services/apis/usuario/empresa.service';
import { NaturezaOperacaoListStruct } from '../../../../../../shared/services/structs/motor-fiscal/natureza-operacao-list.struct';
import { TipoPadraoNaturezaOperacaoStruct } from '../../../../../../shared/services/structs/motor-fiscal/tipo-padrao-natureza-operacao.struct';
import { EmptyListComponent } from '../../../../../../shared/components/empty-list/empty-list.component';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { ConfirmModalComponent } from '../../../../../../shared/components/confirm-modal/confirm-modal.component';
import { LoadingBoxDefaultListComponent } from '../../../../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-naturezas-lista',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSortModule,
        MatTableModule,
        MatDialogModule,
        MatTooltipModule,
        EmptyListComponent,
        AlertCardComponent,
        LoadingBoxDefaultListComponent,
        NgxMaskPipe,
    ],
    providers: [provideNgxMask()],
    templateUrl: './naturezas-lista.component.html',
    styleUrl: './naturezas-lista.component.css',
})
export class NaturezasListaComponent implements OnInit, OnDestroy {
    public moduloEnum = ModuloEnum.Configuracoes;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_NotasFiscais;
    public TipoOperacaoEnum = TipoOperacaoEnum;

    public readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };

    public model: FormGroup;

    public _paginaAtual: number = 1;
    public _tamanhoPagina: number = 20;
    public _totalRegistros: number = 0;

    public _dataSource = new DataSourceOrdenacaoInsensivel<NaturezaOperacaoListStruct>();
    public _allData: NaturezaOperacaoListStruct[] = [];
    public _tiposPadrao: TipoPadraoNaturezaOperacaoStruct[] = [];
    public _isLoading: boolean = false;
    public _seedPendente: boolean = false;
    private _seedDialogAberto: boolean = false;
    /** Situação perante o ICMS lida do cadastro da empresa; nula quando o cadastro não foi lido. */
    private _idSituacaoContribuinteEmpresaCadastro: number | null = null;
    private _resolvendoSeed: boolean = false;
    /** Regime tributário atual da empresa, lido do cadastro; nulo quando o cadastro não foi lido ou não tem regime. */
    private _idRegimeTributarioEmpresa: number | null = null;
    public _descricaoRegimeTributarioEmpresa: string = '';
    /** A empresa não tem natureza ativa do regime atual (ex.: trocou de regime): a tela oferece as naturezas padrão. */
    public _isSemNaturezaRegimeEmpresa: boolean = false;
    public _isCarregandoNaturezasPadrao: boolean = false;

    public displayedColumns: string[] = [
        'select', 'nome', 'tipo', 'regime', 'cfop', 'tributos', 'reformaTributaria', 'padrao', 'status', 'actions'
    ];

    public selection = new SelectionModel<NaturezaOperacaoListStruct>(true, []);

    public tipoOperacaoOptions: { value: number | string; label: string }[] = [
        { value: '', label: 'Todos' },
    ];

    public regimeLabel: Record<number, string> = {
        [RegimeTributarioEnum.SimplesNacional]: 'Simples Nacional',
        [RegimeTributarioEnum.SimplesNacionalExcessoSublimite]: 'Simples Nacional - Excesso/Sublimite',
        [RegimeTributarioEnum.RegimeNormal]: 'Regime Normal',
        [RegimeTributarioEnum.MicroempreendedorIndividual]: 'Microempreendedor Individual (MEI)',
    };

    public tipoLabel: Record<number, string> = {
        [TipoOperacaoEnum.Entrada]: 'Entrada',
        [TipoOperacaoEnum.Saida]: 'Saída',
    };

    /** Nome do tipo de padrão lido do catálogo devolvido junto da listagem. */
    public nomeTipoPadrao(tipo: TipoPadraoNaturezaEnum): string {
        return this._tiposPadrao.find(t => t.idTipoPadraoNaturezaOperacao === tipo)?.nome ?? '';
    }

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this._dataSource.sort = sort;
    }

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private naturezaService: NaturezaOperacaoService,
        private motorFiscalLookupService: MotorFiscalLookupService,
        private empresaService: EmpresaService,
        private alertService: AlertService,
        private utilService: UtilService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.model = this.fb.group({
            pesquisa: [''],
            tipoOperacao: [''],
        });
        this.loadFilters();
        this.carregarRegimeEmpresaENaturezas();
        this.carregarTiposOperacao();
    }

    /**
     * Lê o regime tributário atual da empresa (o mesmo cadastro do seed) e carrega a lista, que avisa quando
     * não há natureza desse regime. Sem a leitura, a lista carrega sem o aviso.
     */
    private carregarRegimeEmpresaENaturezas(): void {
        this._isLoading = true;

        forkJoin({
            cadastro: this.empresaService.obterRegimeTributario(),
            regimes: this.motorFiscalLookupService.getRegimesTributarios(),
        }).subscribe({
            next: ({ cadastro, regimes }) => {
                const idRegime = cadastro.isError ? null : (cadastro.idRegimeTributario ?? null);
                this._idRegimeTributarioEmpresa = idRegime;
                this._descricaoRegimeTributarioEmpresa = idRegime == null
                    ? ''
                    : regimes.find(x => x.id === idRegime)?.descricao ?? this.regimeLabel[idRegime] ?? '';
                this.clickPesquisar();
            },
            error: () => {
                this._idRegimeTributarioEmpresa = null;
                this.clickPesquisar();
            },
        });
    }

    private carregarTiposOperacao(): void {
        this.motorFiscalLookupService.getDominios().subscribe({
            next: dominios => {
                this.tipoOperacaoOptions = [
                    { value: '', label: 'Todos' },
                    ...dominios.tiposOperacao.map(t => ({ value: t.id, label: t.descricao })),
                ];
            },
            error: () => { /* mantém "Todos" já disponível se o lookup falhar */ },
        });
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, []);
    }

    private loadFilters(): void {
        const saved = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (saved) this.model.patchValue(saved);
    }

    public carregarNaturezas(reset: boolean = false): void {
        this._isLoading = true;
        const pesquisa = this.model.get('pesquisa')?.value || null;
        const tipoOperacao = this.model.get('tipoOperacao')?.value || null;

        this.naturezaService.getAll(pesquisa, tipoOperacao, this._paginaAtual, this._tamanhoPagina,
            this._idRegimeTributarioEmpresa).subscribe({
            next: response => {
                this._isLoading = false;
                this._isCarregandoNaturezasPadrao = false;
                if (response.isError) {
                    this._isSemNaturezaRegimeEmpresa = false;
                    if (response.errorCode === NaturezaOperacaoErrorCodeEnum.SeedPendente) {
                        // Sem naturezas: resolve o regime tributário da empresa e chama o seed (forma definitiva,
                        // a mesma do DIFAL e da regra tributária).
                        this._seedPendente = true;
                        this.resolverSeedPendente();
                        return;
                    }
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao carregar naturezas', AlertType.error);
                    return;
                }
                this._seedPendente = false;
                this._isSemNaturezaRegimeEmpresa = response.isSemNaturezaRegimeEmpresa === true;
                this._totalRegistros = response.totalRegistros;
                this._tiposPadrao = response.tiposPadrao ?? [];
                if (reset) {
                    this._allData = response.naturezas;
                    this.selection.clear();
                } else {
                    this._allData = [...this._allData, ...response.naturezas];
                }
                this._dataSource.data = this._allData;
            },
            error: err => {
                this._isLoading = false;
                this._isCarregandoNaturezasPadrao = false;
                this.alertService.show('Erro inesperado', err.message || 'Erro ao carregar naturezas', AlertType.error);
            },
        });
    }

    /**
     * Aviso de empresa sem natureza do regime atual: o mesmo fluxo do seed inicial, com o regime (e a apuração,
     * no Regime Normal) lido do cadastro da empresa; o seed cria as naturezas padrão desse regime.
     */
    public carregarNaturezasPadrao(): void {
        this._isCarregandoNaturezasPadrao = true;
        this.resolverSeedPendente();
    }

    // ── Seed inicial das naturezas ───────────────────────────────────────────

    /**
     * Retomada manual, do empty state: o usuário cancelou o modal e quer voltar a ele. Passa pela
     * resolução inteira de novo — o cadastro pode ter sido preenchido em outra aba nesse meio.
     */
    public informarRegimeTributario(): void {
        this.resolverSeedPendente();
    }

    /**
     * O seed precisa do regime tributário, e a empresa pode já tê-lo respondido em
     * Configurações > Empresa — aí roda direto, sem perguntar. Só quando o cadastro não responde
     * o modal entra, e a resposta é gravada lá para a pergunta não voltar em outras rotinas.
     *
     * Falha na consulta cai no modal SEM gravar: não sabemos o que estaríamos sobrescrevendo.
     */
    private resolverSeedPendente(): void {
        if (this._seedDialogAberto || this._resolvendoSeed) return;

        this._resolvendoSeed = true;
        this._isLoading = true;

        forkJoin({
            cadastro: this.empresaService.obterRegimeTributario(),
            regimes: this.motorFiscalLookupService.getRegimesTributarios(),
        }).subscribe({
            next: ({ cadastro, regimes }) => {
                this._resolvendoSeed = false;
                this._idSituacaoContribuinteEmpresaCadastro = cadastro.isError ? null : (cadastro.idSituacaoContribuinteEmpresa ?? null);

                if (cadastro.isError) {
                    this.perguntarRegime('naoConsultado', false);
                    return;
                }

                const idRegime = cadastro.idRegimeTributario;
                // O que identifica o Regime Normal é o `codigo` do catálogo, não o id.
                const codigo = idRegime == null
                    ? null
                    : regimes.find(x => x.id === idRegime)?.codigo ?? null;

                const seed = this.montarSeedDoCadastro(idRegime, codigo, cadastro.idRegimeApuracaoIrpj);
                if (seed) {
                    this.semear(seed, 'Naturezas de operação criadas com base no regime tributário da empresa.', true);
                    return;
                }

                // Só gravamos quando entendemos o que estava lá. Regime que não resolve pode ser
                // lookup falhando em silêncio (`getList` devolve lista vazia em erro) — aí
                // perguntar é seguro, sobrescrever não.
                if (idRegime == null) {
                    this.perguntarRegime('semRegime', true);
                } else if (codigo == null) {
                    this.perguntarRegime('naoConsultado', false);
                } else {
                    // Regime reconhecido e é o Regime Normal — o que falta é a apuração.
                    this.perguntarRegime('semApuracao', true);
                }
            },
            error: () => {
                this._resolvendoSeed = false;
                this.perguntarRegime('naoConsultado', false);
            },
        });
    }

    /**
     * @param motivo o que dizer ao usuário sobre o porquê da pergunta.
     * @param gravarNoCadastro grava a resposta em Configurações > Empresa. Só quando sabemos que
     * não há resposta boa lá para sobrescrever.
     */
    private perguntarRegime(motivo: MotivoSeedRegime, gravarNoCadastro: boolean): void {
        // `_isLoading` continua true enquanto o modal está aberto: soltá-lo aqui faria a tela de
        // fundo renderizar o empty state "Catálogo ainda não inicializado", com um botão que pede
        // exatamente o que o modal na frente já está perguntando. Quem solta é o afterClosed.
        this.abrirModalSeed({ motivo, gravarNoCadastro });
    }

    /**
     * Traduz o cadastro num request de seed — ou null quando ele não responde o suficiente e o
     * usuário ainda precisa ser perguntado.
     */
    private montarSeedDoCadastro(
        idRegimeTributario: number | null,
        codigoRegimeTributario: string | null,
        idRegimeApuracaoIrpj: number | null
    ): NaturezaOperacaoSeedRequest | null {
        // Regime ausente, ou gravado mas fora do catálogo ativo — que o seed recusaria.
        if (idRegimeTributario == null || codigoRegimeTributario == null) return null;

        // Fora do Regime Normal o seed recusa apuração; descarta o que estiver gravado.
        const idSituacaoContribuinteEmpresa = this._idSituacaoContribuinteEmpresaCadastro;
        if (codigoRegimeTributario !== RegimeTributarioEnum.RegimeNormal.toString()) {
            return { idRegimeTributario, idRegimeApuracaoIrpj: null, idSituacaoContribuinteEmpresa };
        }

        if (idRegimeApuracaoIrpj == null) return null;

        return { idRegimeTributario, idRegimeApuracaoIrpj, idSituacaoContribuinteEmpresa };
    }

    /**
     * `disableClose` e sem Cancelar: o seed não roda sem uma resposta, e a tela não tem nada a
     * mostrar antes dele. Fechar por ESC ou clique fora só levaria a uma lista vazia.
     */
    private abrirModalSeed(dados: RegimeTributarioSeedDialogData): void {
        if (this._seedDialogAberto) return;

        this._seedDialogAberto = true;
        const dialogRef = this.dialog.open(RegimeTributarioSeedDialogComponent, {
            width: '560px',
            maxWidth: '95vw',
            disableClose: true,
            data: dados,
        });

        dialogRef.afterClosed().subscribe((request: NaturezaOperacaoSeedRequest | undefined) => {
            this._seedDialogAberto = false;

            // Fechou sem responder (só por fechamento programático — o modal não tem Cancelar):
            // libera a tela para o empty state, que traz o botão de retomar.
            if (!request) {
                this._isLoading = false;
                this._isCarregandoNaturezasPadrao = false;
                return;
            }

            this.semearRespostaDoUsuario(request, dados.gravarNoCadastro);
        });
    }

    /**
     * @param gravarNoCadastro falso quando não conseguimos ler o cadastro: aí a resposta serve só
     * para este seed, porque gravá-la poderia apagar um regime correto.
     */
    private semearRespostaDoUsuario(request: NaturezaOperacaoSeedRequest, gravarNoCadastro: boolean): void {
        this._isLoading = true;
        // O modal pergunta só o regime; a situação perante o ICMS continua sendo a do cadastro.
        request = { ...request, idSituacaoContribuinteEmpresa: this._idSituacaoContribuinteEmpresaCadastro };

        const mensagemSucesso = 'Naturezas de operação criadas com sucesso.';

        if (!gravarNoCadastro) {
            this.semear(request, mensagemSucesso, false);
            return;
        }

        // Não conseguir gravar o regime no cadastro não justifica abortar o seed — o usuário já
        // respondeu o que era preciso. Avisa e segue.
        this.empresaService.salvarRegimeTributario({
            idRegimeTributario: request.idRegimeTributario,
            idRegimeApuracaoIrpj: request.idRegimeApuracaoIrpj,
        }).subscribe({
            next: response => {
                if (response.isError) this.avisarRegimeNaoSalvo(response.errorDescription);
                this.semear(request, mensagemSucesso, false);
            },
            error: () => {
                this.avisarRegimeNaoSalvo();
                this.semear(request, mensagemSucesso, false);
            },
        });
    }

    /**
     * @param motivo mensagem da API. A recusa mais provável é permissão, e aí o motivo diz onde
     * alterar — o que a mensagem genérica não diria.
     */
    private avisarRegimeNaoSalvo(motivo?: string): void {
        const detalhe = (motivo ?? '').trim();

        this.alertService.show(
            'Atenção',
            detalhe
                ? `As naturezas serão criadas, mas o regime tributário não foi salvo no cadastro da empresa: ${detalhe}`
                : 'As naturezas serão criadas, mas não foi possível salvar o regime tributário no cadastro da empresa.',
            AlertType.warning
        );
    }

    /**
     * @param permitirModalNaFalha se o regime lido do cadastro for recusado pelo seed, abre o
     * modal para o usuário corrigir em vez de deixar a tela vazia.
     */
    private semear(request: NaturezaOperacaoSeedRequest, mensagemSucesso: string, permitirModalNaFalha: boolean): void {
        this._isLoading = true;

        this.alertService.show('Informação', 'Carregando as configurações base...', AlertType.info);
        this.naturezaService.seed(request).subscribe({
            next: response => {
                if (response.isError) {
                    this._isLoading = false;
                    this._isCarregandoNaturezasPadrao = false;
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao inicializar as naturezas', AlertType.error);
                    if (permitirModalNaFalha) this.perguntarRegime('regimeRecusado', true);
                    return;
                }
                this._seedPendente = false;
                this.alertService.show('Sucesso', mensagemSucesso, AlertType.success);
                // O modal pode ter gravado o regime no cadastro da empresa: relê o regime antes de listar.
                this.carregarRegimeEmpresaENaturezas();
            },
            error: err => {
                this._isLoading = false;
                this._isCarregandoNaturezasPadrao = false;
                this.alertService.show('Erro inesperado', err.message || 'Erro ao inicializar as naturezas', AlertType.error);
            },
        });
    }

    public get qtdFiltrosAvancados(): number {
        return this.model?.get('tipoOperacao')?.value ? 1 : 0;
    }

    public clickPesquisar(): void {
        this._paginaAtual = 1;
        this._allData = [];
        this._dataSource.data = [];
        this.selection.clear();
        this.carregarNaturezas(true);
    }

    public aplicarFiltros(): void {
        this.clickPesquisar();
    }

    public limparFiltros(): void {
        this.model.reset({ pesquisa: '', tipoOperacao: '' });
        this.clickPesquisar();
    }

    public proximaPagina(): void {
        this._paginaAtual++;
        this.carregarNaturezas();
    }

    public isAllSelected(): boolean {
        return this.selection.selected.length === this._dataSource.data.length && this._dataSource.data.length > 0;
    }

    public toggleAllRows(): void {
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            this.selection.select(...this._dataSource.data);
        }
    }

    public editarNatureza(id: number): void {
        this.router.navigate(['/configuracoes/notas-fiscais/natureza-operacao/cadastrar', id]);
    }

    public alternarStatus(item: NaturezaOperacaoListStruct): void {
        const novoStatus = !item.isAtivo;
        this.naturezaService.alterarStatus(item.idNaturezaOperacao, novoStatus).subscribe({
            next: response => {
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao alterar o status', AlertType.error);
                    return;
                }
                item.isAtivo = novoStatus;
                // O status gera uma nova versão (id novo): recarrega para as próximas ações usarem a versão atual.
                this.carregarNaturezas();
                this.alertService.show('Sucesso', `Natureza ${novoStatus ? 'ativada' : 'inativada'} com sucesso.`, AlertType.success);
            },
            error: err => {
                this.alertService.show('Erro inesperado', err.message || 'Erro ao alterar o status', AlertType.error);
            },
        });
    }

    public confirmarExclusao(item: NaturezaOperacaoListStruct): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirmar Exclusão',
                description: `Você tem certeza que deseja excluir a natureza de operação "${item.nome}"? Esta ação não poderá ser desfeita.`,
                buttonConfirm: 'Confirmar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm) {
                this.excluirNatureza(item.idNaturezaOperacao);
            }
        });
    }

    private excluirNatureza(id: number): void {
        this.naturezaService.excluir(id).subscribe({
            next: response => {
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription || 'Erro ao excluir', AlertType.error);
                    return;
                }
                this.alertService.show('Sucesso', 'Natureza excluída com sucesso.', AlertType.success);
                this.clickPesquisar();
            },
            error: err => {
                this.alertService.show('Erro inesperado', err.message || 'Erro ao excluir', AlertType.error);
            },
        });
    }

    public duplicarNatureza(id: number): void {
        this.router.navigate(['/configuracoes/notas-fiscais/natureza-operacao/cadastrar'], {
            queryParams: { duplicateFrom: id }
        });
    }

    public abrirTornarPadrao(item: NaturezaOperacaoListStruct): void {
        const dialogRef = this.dialog.open(TornarPadraoDialogComponent, {
            width: '600px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            data: { natureza: item, tiposPadrao: this._tiposPadrao }
        });

        dialogRef.afterClosed().subscribe((result: TornarPadraoDialogResult | undefined) => {
            if (result && result.confirm) {
                this.naturezaService.tornarPadrao(item.idNaturezaOperacao, {
                    tiposPadrao: result.tiposPadrao,
                }).subscribe({
                    next: response => {
                        if (response.isError) {
                            this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                            return;
                        }
                        this.alertService.show('Sucesso', 'Padrões da natureza salvos.', AlertType.success);
                        this.clickPesquisar();
                    },
                    error: () => {
                        this.alertService.show('Aviso',
                            'Não foi possível salvar os padrões da natureza agora. Tente novamente em alguns instantes.',
                            AlertType.warning);
                    }
                });
            }
        });
    }

    public avisoEmBreve(): void {
        this.alertService.show('Em breve', 'Este fluxo será implementado futuramente.', AlertType.info);
    }
}
